export function MiniNetwork() {
  return (
    <svg class="obs-mini-net" viewBox="0 0 180 88" aria-hidden="true">
      <line x1="16" y1="44" x2="58" y2="22" />
      <line x1="16" y1="44" x2="58" y2="66" />
      <line x1="58" y1="22" x2="108" y2="16" />
      <line x1="58" y1="22" x2="108" y2="44" />
      <line x1="58" y1="66" x2="108" y2="44" />
      <line x1="58" y1="66" x2="108" y2="72" />
      <line class="obs-mini-hotline" x1="108" y1="44" x2="160" y2="44" />
      <circle cx="16" cy="44" r="5" />
      <circle cx="58" cy="22" r="4" />
      <circle cx="58" cy="66" r="4" />
      <circle cx="108" cy="16" r="3.5" />
      <circle class="obs-mini-core" cx="108" cy="44" r="5" />
      <circle cx="108" cy="72" r="3.5" />
      <circle class="obs-mini-core" cx="160" cy="44" r="5.5" />
    </svg>
  );
}

export function MiniBars() {
  const rows = [
    { label: "Lab", w: 118 },
    { label: "Data", w: 86 },
    { label: "Research", w: 132 },
    { label: "Transfer", w: 72 },
  ];
  return (
    <svg class="obs-mini-bars" viewBox="0 0 180 88" aria-hidden="true">
      {rows.map((row, i) => (
        <g key={row.label} transform={`translate(8 ${8 + i * 20})`}>
          <text x="0" y="11" class="obs-mini-caption">
            {row.label}
          </text>
          <rect class="obs-mini-track" x="52" width="120" height="8" rx="4" />
          <rect class="obs-mini-fill" x="52" width={row.w} height="8" rx="4" />
        </g>
      ))}
    </svg>
  );
}
